import { Injectable, inject } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { captureException } from '@sentry/angular';

export type updateCheckResponse = {
  update: boolean;
  updatedAt?: string;
  translations?: Record<string, string>;
};

@Injectable({
  providedIn: 'root',
})
export class TranslationUpdateCheckerService {
  private apollo = inject(Apollo);

  constructor() {}

  checkForUpdates(
    locale: string,
    updatedAt: string,
  ): Observable<updateCheckResponse> {
    const TRANSLATION_UPDATE_CHECKER_QUERY = gql`
      query TranslationUpdateChecker($locale: String!, $updatedAt: String!) {
        checkTranslationUpdates(locale: $locale, updatedAt: $updatedAt)
      }
    `;

    return this.apollo
      .query<any>({
        query: TRANSLATION_UPDATE_CHECKER_QUERY,
        variables: { locale, updatedAt },
        fetchPolicy: 'network-only', // Always fetch latest data
      })
      .pipe(
        map((result) => result.data.checkTranslationUpdates),
        catchError((error) => {
          captureException(error);
          console.error('Error in translation update checker:', error);
          throw error; // Re-throw so the subscriber can handle it
        }),
      );
  }
}
